import { path, pathOr } from 'core/utils';

export const mediateTaskListInfoDependent = path(['layout', 'taskList']);
export const mediateSearchLayoutInfoDependent = path(['layout', 'search']);
export const mediateEntryDialogsLayoutInfoDependent = pathOr({showAddEntry : false}, ['layout', 'entryDialogs']);
export const mediateEntriesLayoutInfoDependent = path(['layout', 'entries']);
